import React from "react";
import Pagination from "rc-pagination";
import {locale} from "../../common/table/paginatorConfig";
import { SortIcons } from "components/SortIcons/SortIcons";
import { IPageResponse, SortDirection } from "common/interfaces/IPageResponse";
import { CHARGING_FEE_CALCULATION_TYPE_MAP, ChargingReportConfiguration, ChargingReportConfigurationSortFields } from "./models";
import { dateFormatOptions } from "common/dateFormatterConfig";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { ModalType } from "common/common-models";

interface ChargingReportConfigurationsTableProps {
  configurations?: IPageResponse<ChargingReportConfiguration>;
  onPageChange: (page: number, size: number) => void;
  onSort: (sortField: ChargingReportConfigurationSortFields) => void;
  sortField: ChargingReportConfigurationSortFields;
  sortDirection: SortDirection;
  openEditChargingReportConfigurationModal: (modalType: ModalType, chargingReportConfigurations: ChargingReportConfiguration) => void;
  openDeleteChargingReportConfigurationModal: (configuration: ChargingReportConfiguration) => void;
  isRequesting: boolean;
}

export function ChargingReportConfigurationsTable(props: ChargingReportConfigurationsTableProps) {
    const chargingReportConfigurations: Array<ChargingReportConfiguration> = props.configurations ? props.configurations.content : [];
    const pageResponse = props.configurations;

    const configurationTableRows = chargingReportConfigurations.map((configuration) =>
        <tr key={'row-' + configuration.id}>
            <td className="text-nowrap">
                {configuration.id}<br />
            </td>
            <td className="line-height-1">
                {configuration.externalChargingStationId}<br />
            </td>
            <td className="text-nowrap">
                {configuration.chargingStationName}
            </td>
            <td className="text-nowrap">
                {configuration.scheduledDay}
            </td>
            <td className="text-nowrap">
                {CHARGING_FEE_CALCULATION_TYPE_MAP[configuration.feeCalculationType]}
            </td>
            <td className="text-nowrap">
                {configuration.dateCreated ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(configuration.dateCreated)) : ""}
            </td>
            <td>
                <div className="row__actions">
                    <OverlayTrigger 
                        delay={250}
                        overlay={
                            <Tooltip id={`tooltip-${configuration.id}`}>
                                <p style={{margin: '3px'}}>Muuda</p>
                            </Tooltip>
                        } 
                        placement={"left"}
                    >
                        <Button 
                            size="sm" 
                            variant="outline-dark"
                            className="d-flex align-items-center border-color-background border-radius-circle btn-outline-icon"
                            onClick={(e: any) => {
                                props.openEditChargingReportConfigurationModal(ModalType.EDIT, configuration);
                            }}
                        >
                            <i className="icon--16 my-2 icon__edit--outline-mask"/>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger 
                        delay={250}
                        overlay={
                            <Tooltip id={`tooltip-${configuration.id}`}>
                                <p style={{margin: '3px'}}>Kustuta</p>
                            </Tooltip>
                        } 
                        placement={"left"}
                    >
                        <Button size="sm" variant="outline-danger"
                                className="d-flex align-items-center border-color-background border-radius-circle btn-outline-icon"
                                onClick={(e: any) => {
                                    props.openDeleteChargingReportConfigurationModal(configuration);
                                }}>
                            <i className="icon--16 my-2 icon__delete--outline-mask"/>
                        </Button>
                    </OverlayTrigger>
                </div>
            </td>
        </tr>
    );

    return (
        <table className='generic-table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(ChargingReportConfigurationSortFields.ID)}>
                        <span>ID</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={ChargingReportConfigurationSortFields.ID} />
                    </div>
                </th>
                <th>Jaama noom id</th>
                <th>Jaama nimi</th>
                <th>Koostamise päev</th>
                <th>Tasu arvestamise viis</th>
                <th className="text-left">Loodud</th>
            </tr>
            </thead>
            <tbody>
                {
                    props.isRequesting ?
                    <tr>
                        <td colSpan={10} className="spinner-cell">
                            <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="grow" />
                            </div>
                        </td>
                    </tr> : configurationTableRows
                }
            </tbody>
            {
                pageResponse ? (
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <div className="pagination-wrapper">
                                    <Pagination
                                        locale={locale}
                                        current={pageResponse.number + 1}
                                        total={pageResponse.totalElements}
                                        pageSize={pageResponse.size}
                                        prefixCls={"pagination"}
                                        onChange={props.onPageChange}
                                        showSizeChanger={false}
                                        hideOnSinglePage={true}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                ) : null
            }
        </table>
    )
}